import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const loginUsername = createAsyncThunk(
  "loginUsername/loginUsernameUsers",
  async (payload, thunkAPI) => {
    try {
      
       // loginUsername
      const response = await api.post("signin-username", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const loginUsernameSlice = createSlice({
  name: "loginUsername",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUsername.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginUsername.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(loginUsername.rejected, (state, action) => {
       
        console.log(43, action.payload)
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default loginUsernameSlice.reducer;
